import { render, staticRenderFns } from "./promotionchart.vue?vue&type=template&id=b19690e2&"
import script from "./promotionchart.vue?vue&type=script&lang=js&"
export * from "./promotionchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports